import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Map";
import AddProducts from "./AddProductInput";

const AddProduct = () => {
  return (
    <>

      <AddProducts />


    </>
  );
};

export default AddProduct;
